import api from './axios';

export interface Student {
    id: string;
    matricule: string;
    nom: string;
    prenom: string;
    dateNaissance: Date;
    lieuNaissance: string;
    sexe: 'M' | 'F';
    telephone?: string;
    email?: string;
    adresse?: string;
    niveau: '1' | '2' | '3' | '4';
    filiere: string;
    statut: 'actif' | 'inactif' | 'diplome' | 'abandonne';
    anneeAdmission: number;
    photo?: string;
    documents?: Record<string, any>;
    createdAt: Date;
    updatedAt: Date;
}

export interface CreateStudentData {
    nom: string;
    prenom: string;
    dateNaissance: string;
    lieuNaissance: string;
    sexe: 'M' | 'F';
    telephone?: string;
    email?: string;
    adresse?: string;
    niveau: '1' | '2' | '3' | '4';
    filiere: string;
    statut?: 'actif' | 'inactif' | 'diplome' | 'abandonne';
    anneeAdmission: number;
    photo?: string;
    documents?: Record<string, any>;
}

export const getStudents = async (): Promise<Student[]> => {
    const response = await api.get(`/students/all-students`);
    return response.data;
};

export const getStudentById = async (id: string): Promise<Student> => {
    const response = await api.get(`/students/${id}`);
    return response.data;
};

export const getStudentByMatricule = async (matricule: string): Promise<Student> => {
    const response = await api.get(`/students/matricule/${matricule}`);
    return response.data;
};

export const getStudentsByStatut = async (statut: string): Promise<Student[]> => {
    const response = await api.get(`/students/all-students?statut=${statut}`);
    return response.data;
};

export const getStudentsByFiliere = async (filiere: string): Promise<Student[]> => {
    const response = await api.get(`/students/all-students?filiere=${filiere}`);
    return response.data;
};

export const createStudent = async (data: CreateStudentData): Promise<Student> => {
    const response = await api.post(`/students/add-student`, data);
    return response.data;
};

export const updateStudent = async (id: string, data: Partial<CreateStudentData>): Promise<Student> => {
    const response = await api.patch(`/students/update-student/${id}`, data);
    return response.data;
};

export const deleteStudent = async (id: string): Promise<void> => {
    await api.delete(`/students/delete-student/${id}`);
};
